export const LoadingSpinner = () => (
  <div className="loading-container">
    <div className="loading-spinner">
      <div className="loading-circle"></div>
    </div>
    <p className="loading-text">Loading user details...</p>
  </div>
);